import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CardBox } from '../card-box';
import Carousel from '../carousel';
import { IconButton } from '../icon-button';

export const Wrapper = styled(CardBox)`
  width: 100%;
`;

export const Actions = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(1)};
  justify-content: flex-end;

  > .MuiIconButton-root {
    padding: ${(p) => p.theme.spacing(0, 0.5)};
  }
`;

export const Slider = styled(Carousel)<{ empty: boolean }>`
  .slick-track {
    display: flex;
    margin: ${(p) => (p.empty ? 'auto' : 'none')};
    justify-content: ${(p) => (p.empty ? 'center' : 'unset')};
    > .slick-slide {
      align-items: ${(p) => (p.empty ? 'center' : 'unset')};
    }
  }

  .slick-dots {
    display: none !important;
  }

  .slick-slide > div {
    padding: 0 ${(p) => p.theme.spacing(0.25)};
  }
  .slick-slide > div > div {
    width: 100%;
  }
`;

export const NavIcon = styled(IconButton)`
  padding: ${(p) => p.theme.spacing(0.5)};
  &:not(.Mui-disabled) {
    :hover {
      color: ${(p) => p.theme.palette.primary[500]};
      background-color: transparent;
    }
  }
  &.Mui-disabled {
    color: ${(p) => p.theme.palette.grey[400]};
  }
`;
